import { useEffect, useRef } from 'react';
import { CalendarState, RangeCalendarState } from 'react-stately';

import isRangeCalendarContext from '../helpers/isRangeCalendarContext';

type UseSelectingRangeProps = {
    context: RangeCalendarState | CalendarState;
    onChange?: (selectingRange: boolean) => void;
};

const useSelectingRange = ({
    context,
    onChange,
}: UseSelectingRangeProps): boolean => {
    const lastState = useRef<boolean>(false);

    const newState = isRangeCalendarContext(context) && !!context.anchorDate;

    useEffect(() => {
        if (onChange && lastState.current !== newState) {
            onChange(newState);
        }

        lastState.current = newState;
    }, [newState]);

    return lastState.current;
};

export default useSelectingRange;
